import axiosInstance from '../../config/axiosConfig';
import { urlVulnerabilidades } from '../../config/apiURL';
import { extractArray, extractDataObject } from '../utils/responseHelpers';

export async function getVulnerabilidades() {
  try {
    const response = await axiosInstance.get(urlVulnerabilidades);
    return extractArray(response);
  } catch (error) {
    console.error('Error fetching vulnerabilities:', error);
    throw error;
  }
}   

export async function getVulnerabilidadPorEmpresa(emp_codigo) {
  try {
    const response = await axiosInstance.get(`${urlVulnerabilidades}/empresa/${emp_codigo}`);
    return extractArray(response);
  } catch (error) {
    console.error('Error fetching vulnerabilities by company:', error);
    throw error;
  }
}

export async function getVulnerabilidadPorId(id) {
  try {
    const response = await axiosInstance.get(`${urlVulnerabilidades}/${id}`);
    return extractDataObject(response);
  } catch (error) {
    console.error(`Error fetching vulnerabilidad ${id}:`, error);
    throw error;
  }
}

export async function updateVulnerabilidades(id, formulario) {
  try {
    const response = await axiosInstance.put(`${urlVulnerabilidades}/${id}`, formulario);
    return extractDataObject(response);
  } catch (error) {
    console.error(`Error updating vulnerabilidad ${id}:`, error);
    throw error;
  }
}

export async function createVulnerabilidades(formulario) {
  try {
    const response = await axiosInstance.post(urlVulnerabilidades, formulario);
    return extractDataObject(response);
  } catch (error) {
    console.error('Error creating vulnerabilidad:', error);
    throw error;
  }
}

export async function deleteVulnerabilidades(id) {
  try {
    const response = await axiosInstance.delete(`${urlVulnerabilidades}/${id}`);
    return extractDataObject(response);
  } catch (error) {
    console.error(`Error deleting vulnerabilidad ${id}:`, error);
    throw error;
  }
}